export default __webpack_public_path__ + "static/media/job-offer.20e4bf92.png";